<template>
  <div class="order-purchase-part-select">
    <v-combobox
      v-model="localValue.purchase.partSelect.selectedParts"
      :items="parts"
      multiple
      :filter="searchFilter"
      placeholder="Search part number"
      item-text="clientPartNo"
      flat
      filled
      return-object
    >
      <template #append>
        <v-icon>
          mdi-magnify
        </v-icon>
      </template>
      <template
        slot="item"
        slot-scope="{ item }"
      >
        <v-row>
          <v-col cols="auto">
            <span>
              {{ item.clientPartNo }}
            </span>
          </v-col>
          <v-col cols="auto">
            <v-chip x-small>
              <!-- TODO this is going to come from the store at some point -->
              {{ _.indexOf(parts, item) % 2 === 0 ? 'Catalog' : 'Orders' }}
            </v-chip>
          </v-col>
          <v-spacer />
          <v-col cols="auto">
            <v-img
              src="/img/placeholder_item_1.png"
              width="30px"
              height="30px"
            />
          </v-col>
        </v-row>
      </template>
    </v-combobox>

    <v-divider />

    <core-main-table
      :items="localValue.purchase.partSelect.selectedParts"
      :headers="selectedPartsHeaders"
    >
      <template #item.clientPartNo="{ item }">
        <span>
          <!-- Dirty temporary solution for formatting -->
          {{ ('000' + (_.indexOf
            (localValue.purchase.partSelect.selectedParts, item) + 1))
            .slice(-('000'.length))
          }}
        </span>
      </template>

      <template #item.quantity="{ item }">
        <v-text-field
          v-model="localValue.purchase.partSelect.selectedParts
            [_.indexOf(localValue.purchase.partSelect.selectedParts, item)].quantity"
          flat
          dense
          hide-details
          type="number"
        />
      </template>

      <template #item.pricing="{ item }">
        <span>
          {{ formatCurrency(getItemPrice(item) * item.quantity) }}
        </span>
      </template>

      <template #item.delete="{ item }">
        <span>
          <v-btn
            text
            x-small
            fab
            @click="localValue.purchase.partSelect.selectedParts.splice
              (_.indexOf(localValue.purchase.partSelect.selectedParts, item), 1)"
          >
            <v-icon small>
              mdi-delete
            </v-icon>
          </v-btn>
        </span>
      </template>
    </core-main-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModelableMixin from '../../../../mixins/modelable';
import CurrencyFormatterMixin from '../../../../../mixins/currencyFormatter';

export default {
  name: 'PartSelect',

  mixins: [
    ModelableMixin,
    CurrencyFormatterMixin,
  ],

  computed: {
    ...mapGetters('parts', { findPartsFromStore: 'find' }),

    parts() {
      return this.findPartsFromStore({ query: {} }).data;
    },

    selectedPartsHeaders() {
      return [
        {
          text: 'Line #',
          value: 'clientPartNo',
        },
        {
          text: 'Part number / description',
          value: 'manufacturerPartNo',
        },
        {
          text: 'Quantity',
          value: 'quantity',
        },
        {
          text: 'Net price',
          value: 'pricing',
        },
        {
          text: '',
          value: 'delete',
          sortable: false,
        },
      ];
    },
  },

  mounted() {
    this.findPartsFromBackend({ query: {} });
  },

  methods: {
    ...mapActions('parts', { findPartsFromBackend: 'find' }),

    searchFilter(item, queryText, itemText) {
      return _.find(_.values(item), value => _.includes(value, queryText));
    },

    getItemPrice(item) {
      const sortedByPrice = _.sortBy(item.pricing, p => p.minQuantity);
      const itemPrice = _.find(sortedByPrice, p => p.minQuantity >= item.quantity);
      if (itemPrice) {
        return itemPrice.price;
      }
      return item.quantity ? _.last(sortedByPrice).price : 0;
    },
  },
};
</script>

<style scoped>

</style>
